import { render, staticRenderFns } from "./ShopFriendEarn.vue?vue&type=template&id=268f6d97&"
import script from "./ShopFriendEarn.vue?vue&type=script&lang=js&"
export * from "./ShopFriendEarn.vue?vue&type=script&lang=js&"
import style0 from "./ShopFriendEarn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports